import { Row, Col, Form, Input, Card } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { dodPersonalInformationConfig } from './formConfig';

const 
config = dodPersonalInformationConfig,
{ key } = config,
{ generateFormItem, generateInputComponent } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class DodPersonalInformation extends React.Component {
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    render() {
        const
        { services, registrationForm } = this.props,
        { storeFormField, storeForm } = services,
        form = registrationForm[key];
        return (
            <div>
                <Row type='flex' justify='center' style={{ marginBottom: '20px' }}>
                    <Col span={18}>
                        <Card
                            hoverable
                            bodyStyle={{ padding: '10px 10px 10px 10px' }}
                            style={{ cursor: 'default' }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                {'Please enter the following information '}
                                <span style={{ fontWeight: 'bold' }}>
                                    {'EXACTLY'}
                                </span>
                                {' as it appears on your current, valid identification:'}
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='center'>
                    <Col span={23}>
                        <Row gutter={12} type='flex' justify='center'>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('firstName', config, form)}>
                                    <Input {...{...generateInputComponent('firstName', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('middleName', config, form)}>
                                    <Input {...{...generateInputComponent('middleName', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('lastName', config, form)}>
                                    <Input {...{...generateInputComponent('lastName', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
